// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
'use strict';

export const pageSettings = {
  pageSidebarMinified: true,
  pageContentFullHeight: false,
  pageContentFullWidth: false,
  pageContentInverseMode: false,
  pageContentGreyBackground: false,
  pageContentCustomLayout: false,
  pageWithFooter: false,
  pageWithoutSidebar: false,
  pageSidebarRight: false,
  pageSidebarRightCollapsed: false,
  pageSidebarTwo: false,
  pageSidebarWide: false,
  pageSidebarTransparent: false,
  pageSidebarLight: false,
  pageTopMenu: false,
  pageEmpty: false,
  pageBodyWhite: false,
  pageMegaMenu: false,
  pageLanguageBar: false,
  pageMobileSidebarToggled: false,
  pageMobileSidebarFirstClicked: false,
  pageMobileSidebarRightToggled: false,
  pageMobileSidebarRightFirstClicked: false,
  pageMobileTopMenuToggled: false,
  pageMobileMegaMenuToggled: false,
  pageHelpSupportFrame: false,
  pageHelpMenu: false,
};
